import { useEffect, useRef, useState } from 'react';

export interface ToastMessage {
  id: number;
  text: string;
  type: 'error' | 'success' | 'info';
}

let _nextId = 1;

/** Dispatch from anywhere in the app — no React context needed. */
export function showToast(text: string, type: ToastMessage['type'] = 'error') {
  window.dispatchEvent(new CustomEvent('cl:toast', { detail: { text, type } }));
}

export function ToastContainer() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);
  const timers = useRef<Map<number, ReturnType<typeof setTimeout>>>(new Map());

  useEffect(() => {
    const handler = (e: Event) => {
      const { text, type } = (e as CustomEvent<{ text: string; type: ToastMessage['type'] }>).detail;
      const id = _nextId++;
      setToasts(prev => [...prev.slice(-4), { id, text, type }]);
      timers.current.set(id, setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
        timers.current.delete(id);
      }, 5000));
    };
    window.addEventListener('cl:toast', handler);
    return () => window.removeEventListener('cl:toast', handler);
  }, []);

  if (!toasts.length) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 20, right: 20, zIndex: 9999,
      display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 360,
    }}>
      {toasts.map(t => (
        <div key={t.id} style={{
          padding: '10px 14px',
          borderRadius: 6,
          color: '#fff',
          fontSize: 14,
          lineHeight: 1.4,
          boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
          background: t.type === 'error' ? '#dc2626'
            : t.type === 'success' ? '#16a34a'
            : '#2563eb',
          cursor: 'pointer',
        }} onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))}>
          {t.text}
        </div>
      ))}
    </div>
  );
}
